function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// 根据PlacementType计算偏移，基准点为target左上角
// 4个元素分别对应target的宽高和popup的宽高
var placements = {
  tl: [0, 0, 0, -1],
  top: [0.5, 0, -0.5, -1],
  tr: [1, 0, -1, -1],
  rt: [1, 0, 0, 0],
  right: [1, 0.5, 0, -0.5],
  rb: [1, 1, 0, -1],
  br: [1, 1, -1, 0],
  bottom: [0.5, 1, -0.5, 0],
  bl: [0, 1, 0, 0],
  lb: [0, 1, -1, -1],
  left: [0, 0.5, -1, -0.5],
  lt: [0, 0, -1, 0]
};
var arrowMargin = 8;
/**
 * Get all the scrollable parent elements of the element
 * @param ele       The element to be detected
 * @param areaOnly  Only return the parent which will cut visible area
 */

export function collectScroller(ele) {
  var scrollerList = [];
  var current = ele === null || ele === void 0 ? void 0 : ele.parentElement;
  var scrollStyle = ['hidden', 'scroll', 'auto'];

  while (current) {
    var _window$getComputedSt = window.getComputedStyle(current),
        overflowX = _window$getComputedSt.overflowX,
        overflowY = _window$getComputedSt.overflowY;

    if (scrollStyle.includes(overflowX) || scrollStyle.includes(overflowY)) {
      scrollerList.push(current);
    }

    current = current.parentElement;
  }

  return scrollerList;
}
export function placementPopup(placement, target, popup) {
  var hasArrow = Boolean(popup.querySelector('.prism-popup-arrow'));
  var container = popup.offsetParent || document.body;

  var _container$getBoundin = container.getBoundingClientRect(),
      top = _container$getBoundin.top,
      left = _container$getBoundin.left;

  var _target$getBoundingCl = target.getBoundingClientRect(),
      ty = _target$getBoundingCl.top,
      tx = _target$getBoundingCl.left,
      tw = _target$getBoundingCl.width,
      th = _target$getBoundingCl.height;

  var _getRealSizeFromTrans = getRealSizeFromTransform(popup),
      pw = _getRealSizeFromTrans.width,
      ph = _getRealSizeFromTrans.height;

  var _placements$placement = _slicedToArray(placements[placement], 4),
      a = _placements$placement[0],
      b = _placements$placement[1],
      c = _placements$placement[2],
      d = _placements$placement[3];

  var x = tx + tw * a + pw * c - left;
  var y = ty + th * b + ph * d - top;
  var space = hasArrow ? 12 : 4;

  if (placement.startsWith('t')) {
    y -= space;
  } else if (placement.startsWith('b')) {
    y += space;
  } else if (placement.startsWith('l')) {
    x -= space;
  } else if (placement.startsWith('r')) {
    x += space;
  }

  return [x, y];
}
export function placementArrow(placement, popup) {
  var x = 0,
      y = 0;
  var arrowEl = popup.querySelector('.prism-popup-arrow');
  if (!arrowEl) return [x, y];

  var _getRealSizeFromTrans2 = getRealSizeFromTransform(arrowEl, popup),
      width = _getRealSizeFromTrans2.width,
      height = _getRealSizeFromTrans2.height;

  var _getRealSizeFromTrans3 = getRealSizeFromTransform(popup),
      pw = _getRealSizeFromTrans3.width,
      ph = _getRealSizeFromTrans3.height;

  if (placement.startsWith('t') || placement.startsWith('b')) {
    if (placement.startsWith('t')) {
      y = ph - height / 2;
    } else {
      y = -(height / 2) + 3;
    }

    x = getArrowX(pw, width, placement);
  }

  if (placement.startsWith('l') || placement.startsWith('r')) {
    if (placement.startsWith('l')) {
      x = ph - width / 2 + 3;
    } else {
      x = -(width / 2) + 3;
    }

    x = getArrowY(ph, height, placement);
  }

  return [x, y];
}

function getArrowX(pw, width, placement) {
  var x = 0;

  if (pw < width + arrowMargin * 2) {
    x = (pw - width) / 2;
  } else {
    if (placement.includes('l')) {
      x = 8;
    } else if (placement.includes('r')) {
      x = pw - width - 8;
    } else {
      x = (pw - width) / 2;
    }
  }

  return x;
}

function getArrowY(ph, height, placement) {
  var y = 0;

  if (ph < height + arrowMargin * 2) {
    y = (ph - height) / 2;
  } else {
    if (placement.includes('l')) {
      y = 8;
    } else if (placement.includes('r')) {
      y = ph - height - 8;
    } else {
      y = (ph - height) / 2;
    }
  }

  return y;
}

function getRealSizeFromTransform(el, popup) {
  var _el$getBoundingClient = el.getBoundingClientRect(),
      width = _el$getBoundingClient.width,
      height = _el$getBoundingClient.height;

  var _getComputedStyle = getComputedStyle(popup || el),
      transform = _getComputedStyle.transform; // 考虑transform对实际大小的影响


  var sx = 1,
      sy = 1;

  if (transform.startsWith('matrix(')) {
    var transformArr = transform.slice(7, -1).split(', ');
    sx = Number(transformArr[0]);
    sy = Number(transformArr[3]);
  } else if (transform.startsWith('matrix3d(')) {
    var _transformArr = transform.slice(9, -1).split(', ');

    sx = Number(_transformArr[0]);
    sy = Number(_transformArr[5]);
  }

  return {
    width: width / sx,
    height: height / sy
  };
}